type ShouldRenderOtpGateInputs = Readonly<{
  isPreviewing: boolean;
  hasUnlocked: boolean;
  // Draft-preview grant: the identification gate stands down for it — see MCP_PREVIEW.md#visibility-only.
  canPreviewDraft: boolean;
  requiresGuestIdentification: boolean;
  allPagesFilteredByPassword: boolean;
}>;

/**
 * Decides whether the site-wide OTP gate (WelcomePageOtpGate) should render.
 *
 * Distinct from the wedding `shouldRenderWelcomeGate` computation by design:
 * that one requires `isPotentialWelcomeRoute` because wedding events can mix
 * public and password-protected pages, so a deep-link to a public page
 * should fall through to the layout. A `requiresGuestIdentification` event
 * has no such mix — identity is the unlock condition for the *whole* site,
 * so the gate must render on every route where the BE has filtered content
 * (i.e. `allPagesFilteredByPassword`).
 *
 * Extracted so the deep-link scenario is unit-testable without spinning up
 * the full GuestSiteBody render tree.
 */
export const computeShouldRenderOtpGate = ({
  isPreviewing,
  hasUnlocked,
  canPreviewDraft,
  requiresGuestIdentification,
  allPagesFilteredByPassword,
}: ShouldRenderOtpGateInputs): boolean => {
  return !isPreviewing && !hasUnlocked && !canPreviewDraft && requiresGuestIdentification && allPagesFilteredByPassword;
};
